
/**
 * Classe responsável em manter Usuário.
 */
export class UserCanaDTO {

    usuario: string;
    nomeUsuario: string;

    constructor() { }
}